import { CameraIcon, PlusSmallIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";
import { useLocale } from "../i18n";
import "../styles/season-result-compute.css";

/** Uses CommandForm's existing versioned command, validation and exact retry lock. */
export function SeasonResultComputeReview({ title, snapshotName, invalid, onChange }: {
  title: string; snapshotName?: string; invalid: boolean; onChange: (value: string | undefined) => void;
}) {
  const { w } = useLocale();
  const capturing = snapshotName !== undefined;
  return <section className="season-result-compute-review">
    <div className="season-result-compute-symbol" aria-hidden="true"><ShieldCheckIcon /><span><PlusSmallIcon /></span></div>
    <h3>{w("هل أنت متأكد من احتساب نتيجة", "Compute the results for")} <strong>{title}</strong>{w("؟", "?")}</h3>
    <p>{w("سيتم احتساب الدرجات وترتيب المراكز وفق الضوابط المعتمدة وبيانات الجولات المختومة لهذا الموسم.", "Scores and ranks will be computed using the approved rules and this season’s sealed round data.")}</p>
    <div className="season-result-snapshot-choice">
      <label className="season-result-snapshot-toggle">
        <input type="checkbox" checked={capturing} onChange={e => onChange(e.target.checked ? w(`لقطة موسم (${title})`, `Season snapshot (${title})`).slice(0, 160) : undefined)} />
        <CameraIcon aria-hidden="true" /><span><strong>{w("التقاط لقطة تلقائية وحفظها في سجل اللقطات للنتيجة التي تم احتسابها الآن", "Capture and save a named snapshot of this computation in result history")}</strong>
          <small>{w("احفظ اسمًا واضحًا للرجوع إلى هذا الاحتساب ومراجعته لاحقًا. تبقى نتيجة الاحتساب محفوظة للمراجعة في جميع الحالات.", "Give this computation a clear name for later review. Computation results remain saved for audit in either case.")}</small></span>
      </label>
      {capturing && <label className="season-result-snapshot-name" data-field-path="snapshotName"><span>{w("اسم اللقطة", "Snapshot name")}</span>
        <input value={snapshotName} maxLength={160} required aria-invalid={invalid} onChange={e => onChange(e.target.value)} />
        {invalid && <small className="field-error" role="alert">{w("أدخل اسمًا صالحًا للقطة قبل الاحتساب.", "Enter a valid snapshot name before computing.")}</small>}
      </label>}
    </div>
  </section>;
}
